import { equals } from '@unimpaired/utils'
import { useRef, useEffect } from 'react'

export const usePreviousV2 = <T>(value: T): T | void => {
  const prev = useRef<T | undefined>(undefined)
  const current = useRef<T | undefined>(undefined)

  if (!equals(current?.current, value)) {
    prev.current = current.current
    current.current = value
  }

  return prev?.current
}

export default usePreviousV2
